import DashboardTabMediator from "./DashboardTabMediator";
import StoryVariables from "../../../util/StoryVariables";

export default class DashboardRCCETabMediator extends DashboardTabMediator {
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, dashboardConfig, variableManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._dashboardConfig = dashboardConfig;
        this._variableManager = variableManager;
    }

    initialize() {
        super.initialize();

        const weekNumber = this._variableManager.getVariable(StoryVariables.WEEK_NUMBER)
        const movieClipName = this._dashboardConfig.getRCCEMovieClipPerWeek(weekNumber);
        this._initializeImageContainer(movieClipName);
    }

    _initializeImageContainer(movieClipId) {
        this._target.imageContainer.removeAllChildren();
        const illustration = new lib.MainAssets[movieClipId];
        const illustrationSkin = this._target.imageContainer.addChild(illustration);
    }

    destroy() {
        super.destroy();
    }
    get skin() {
        return this._target;
    }

    get keyDecision() {
        return this._keyDecision;
    }
}